<template>
  <section class="bg-[#2f0b77] text-white py-16 px-6">
    <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
      
      <!-- Imagem ilustrativa -->
      <img
  src="/datacenter/server.svg"
  alt="Servidor e conectividade"
  class="max-w-sm h-auto mx-auto md:mx-0"
/>
      <!-- Texto -->
      <div>
        <h2 class="text-3xl sm:text-4xl font-bold mb-4">Por que escolher a gente?</h2>
        <p class="text-white font-semibold mb-4 leading-relaxed">
          Oferecemos serviços de alto desempenho, com flexibilidade, escalabilidade e automações exclusivas — tudo isso com um preço justo.
        </p>
        <p class="text-white mb-6 leading-relaxed">
          Precisa de uma configuração personalizada? Nosso time comercial está pronto para elaborar a proposta e a solução ideal para o seu negócio.
        </p>
        <a
  href="/atendimento"
  class="bg-[#f9cd5e] text-black font-semibold py-3 px-6 rounded-full hover:bg-yellow-400 transition"
>
  Fale conosco
</a>
      </div>
    </div>
  </section>
</template>
